/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import styles from "./DatePicker.module.css"
import {
    addDays,
    subDays,
    addMonths,
    differenceInMonths,
    format,
    isSameDay,
    lastDayOfMonth,
    startOfMonth
} from "date-fns";

export default function DatePicker({endDate, selectDate, getSelectedDay, color, labelFormat}) {
    const [selectedDate, setSelectedDate] = useState(new Date(selectDate));
    const firstSection = {marginLeft: '40px'};
    let today = new Date(selectDate);
    const startDate = subDays(today, 30);
    const lastDate = addDays(today, endDate || 90);
    const primaryColor = color || 'rgb(54, 105, 238)';
    const selectedStyle = {fontWeight:"bold",width:"45px",height:"45px",borderRadius:"50%",border:`2px solid ${primaryColor}`,color:primaryColor};
    const buttonColor = {background: primaryColor};
    const labelColor= {color: primaryColor}

    const getStyles = (day) => {
        if (isSameDay(day, selectedDate)) {
            return(selectedStyle);
        }
        return null
    };

    const getId = (day) => {
        if (isSameDay(day, selectedDate)) {
            return 'selected'
        } else {
            return ""
        }
    };

    function renderDays() {
        const dayFormat = "E";
        const dateFormat = "d";
        const months = [];
        let days = [];
        for (let i = 0; i <= differenceInMonths(lastDate, startDate); i++) {
            let start, end;
            const month = startOfMonth(addMonths(startDate, i));
            start = i === 0 ? Number(format(startDate, dateFormat)) - 1 : 0;
            end = i === differenceInMonths(lastDate, startDate) ? Number(format(lastDate, "d")) : Number(format(lastDayOfMonth(month), "d"));
            // start = start - 30;
            for (let j = start; j < end; j++) {
                days.push(
                    <div id={`${getId(addDays(month, j))}`}
                         className={styles.dateDayItem}
                         style={getStyles(addDays(month, j))}
                         key={addDays(month, j)}
                         onClick={() => onDateClick(addDays(month, j))}
                    >
                        <div className={styles.dayLabel}>
                            {format(addDays(month, j), dayFormat)}
                        </div>
                        <div className={styles.dateLabel}>
                            {format(addDays(month, j), dateFormat)}
                        </div>
                    </div>
                );
            }
            months.push(
                <div className={styles.monthContainer} key={month}>
                    <span className={styles.monthYearLabel} style={labelColor}>
                        {format(month, labelFormat || "MMMM yyyy")}
                    </span>
                    <div className={styles.daysContainer} style={i===0?firstSection:null}>
                        {days}
                    </div>
                </div>
            );
            days = [];
        }
        return <div id={"container"} className={styles.dateListScrollable}>{months}</div>;
    }

    const onDateClick = day => {
        setSelectedDate(day);
        if (getSelectedDay) {
            getSelectedDay(day);
        }
    };

    useEffect(() => {
        if (getSelectedDay) {
            if (selectDate) {
                getSelectedDay(selectDate);
            } else {
                getSelectedDay(selectDate);
            }
        }
    }, []);

    useEffect(() => {
        if (selectDate) {
            if (!isSameDay(selectedDate, selectDate)) {
                setSelectedDate(selectDate);
                setTimeout(() => {
                    let view = document.getElementById('selected');
                    if (view) {
                        view.scrollIntoView({behavior: "smooth", block: "center"});
                    }
                }, 20);
            }
        }
    }, [selectDate]);

    useEffect(() => {
        setTimeout(() => {
            let view = document.getElementById('selected');
            if (view) {
                view.scrollIntoView({behavior: "smooth", block: "center"});
            }
        }, 20);
    }, [])

    const nextWeek = () => {
        const e = document.getElementById('container');
        const width = e ? e.getBoundingClientRect().width : null;
        e.scrollLeft += width - 200;
    };

    const prevWeek = () => {
        const e = document.getElementById('container');
        const width = e ? e.getBoundingClientRect().width : null;
        e.scrollLeft -= width - 200;
    };

    return (
        <div className={styles.container} style={{transform: "scale(1.2)"}}>
            <div className={styles.buttonWrapper}>
                <button className={styles.button} style={buttonColor} onClick={prevWeek}>←</button>
            </div>
            {renderDays()}
            <div className={styles.buttonWrapper}>
                <button className={styles.button} style={buttonColor} onClick={nextWeek}>→</button>
            </div>
        </div>
    )
}